// extracted by mini-css-extract-plugin
export var validateFileStepCell = "validate-file-step__cell_y9rxz9dUyK6NgEXUx62D";